export default __webpack_public_path__ + "static/media/pot_banner_mobile.0853f143.png";